'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'i',
        { className: 'spaui-task-status' },
        _react2.default.createElement('i', { className: 'spaui-icon-task-done' }),
        _react2.default.createElement('i', { className: 'spaui-icon-task-doing' })
    );
}; /**
   * Tencent is pleased to support the open source community by making SPA UI available.
   * Copyright (C) 2019, a Tencent company. All rights reserved.
   */